import { getTenantId } from "egov-ui-kit/utils/localStorageUtils";
import React, { useEffect } from "react";
import CustomDatePicker from "./CustomDatePicker";

const getCurrentFinancialYear = () => {
  const today = new Date();
  const month = today.getMonth();
  const calendarYear = today.getFullYear();
  const startYear = month >= 3 ? calendarYear : calendarYear - 1;
  const endYearSuffix = (startYear + 1).toString().slice(-2);
  return `${startYear}-${endYearSuffix}`;
};

const DashboardFilters = ({ setFilters, filters, onChange, onApply, onReset, receiptDetails }) => {
  const tenantId = getTenantId();
  const isStateLevelLogin = tenantId && !tenantId.includes(".");
  console.log("isStateLevelLogin",isStateLevelLogin)

  // Financial Year ko current year pe default-select karo jab list load ho aur koi year pehle se selected na ho
  useEffect(() => {
    if (!receiptDetails.financialYears || receiptDetails.financialYears.length === 0) return;
    if (filters.financialYear) return; // user/existing selection ko override mat karo

    const currentFY = getCurrentFinancialYear();
    const matchedYear = receiptDetails.financialYears.find((item) => item.year === currentFY);
    const yearToSelect = matchedYear ? matchedYear.year : receiptDetails.financialYears[0].year;

    const updated = { ...filters, financialYear: yearToSelect };
    setFilters(updated);
    onChange(updated);
  }, [receiptDetails.financialYears]);

  useEffect(() => {
    if (!receiptDetails.ulbTypes || receiptDetails.ulbTypes.length === 0) return;
    if (isStateLevelLogin) return;

    // tenantId se match karo ki ye ULB kis type mein hai
    const matchedUlbType = receiptDetails.ulbTypes.find((ulbType) => ulbType.ulbNames && ulbType.ulbNames.some((ulb) => ulb.tenantId === tenantId));

    if (matchedUlbType) {
      const matchedUlb = matchedUlbType.ulbNames.find((ulb) => ulb.tenantId === tenantId);

      const newFilters = {
        ...filters,
        ulbType: matchedUlbType.name,
        ulbName: matchedUlb ? matchedUlb.tenantId : "",
        tenantId: matchedUlb ? matchedUlb.tenantId : "",
      };

      setFilters(newFilters);
      onChange(newFilters);
    }
  }, [receiptDetails]);

  const selectedUlbType = receiptDetails.ulbTypes ? receiptDetails.ulbTypes.find((item) => item.name === filters.ulbType) : null;

  const ulbNames = selectedUlbType && selectedUlbType.ulbNames ? selectedUlbType.ulbNames : [];

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "ulbType") {
      const updated = { ...filters, ulbType: value, ulbName: "", tenantId:""};
      setFilters(updated);
      onChange(updated);
    } else {
      const updated = { ...filters, [name]: value };
      setFilters(updated);
      onChange(updated);
    }
  };

  return (
    <div className="filter-card">
      <div className="filter-row">
        {/* Financial Year */}
        <div className="filter-group financial-year-sec">
          <label className="filter-label">
            Financial Year <span className="filter-required">*</span>
          </label>
          <div className="filter-select-wrapper">
            <select className="filter-select" name="financialYear" value={filters.financialYear} onChange={handleChange}>
              <option value="">Select Year</option>
              {receiptDetails.financialYears &&
                receiptDetails.financialYears.map((item, index) => (
                  <option key={item.id} value={item.year}>
                    {item.year}
                  </option>
                ))}
            </select>
            <span className="filter-chevron">▾</span>
          </div>
        </div>

        <CustomDatePicker 
        filters={filters}
        onChange={(updatedFilters) => {
    setFilters(updatedFilters);
    onChange(updatedFilters);
  }}
        />

    
         {/* ULB Type */}
        <div className="filter-group">
          <label className="filter-label">ULB Type <span className="filter-required">*</span></label>
          <div className="filter-select-wrapper">
            <select
              className="filter-select"
              name="ulbType"
              value={filters.ulbType}
              onChange={handleChange}
              // disabled={ulbNames.length === 0 || !isStateLevelLogin}
              disabled={!isStateLevelLogin} // ULB login pe lock
            >
              <option value="">Select ULB Type</option>
              {receiptDetails.ulbTypes &&
                receiptDetails.ulbTypes.map((ulbData) => (
                  <option key={ulbData.id} value={ulbData.name}>
                    {ulbData.name}
                  </option>
                ))}
            </select>
            <span className="filter-chevron">▾</span>
          </div>
        </div>

        {/* ULB Name */}
        <div className="filter-group">
          <label className="filter-label">ULB Name</label>
          <div className="filter-select-wrapper">
            <select
              className="filter-select"
              name="ulbName"
              value={filters.ulbName}
              onChange={handleChange}
              disabled={ulbNames.length === 0 || !isStateLevelLogin} // ULB login pe lock
            >
              <option value="">Select ULB</option>
              {ulbNames.map((ulb) => (
                <option key={ulb.tenantId} value={ulb.tenantId}>
                  {ulb.name}
                </option>
              ))}
            </select>
            <span className="filter-chevron">▾</span>
          </div>
        </div>
      

        {/* Buttons */}
       
      </div>
       <div className="filter-btn-group">
          <button className="filter-btn-apply" onClick={onApply}>
            Apply Filter
          </button>
          <button className="filter-btn-reset" onClick={onReset}>
            Reset
          </button>
        </div>
    </div>
  );
};

export default DashboardFilters;


// WEBPACK FOOTER //
// src/modules/employee/Home/DashboardFilters.js